import ReactScatterGraph from "./scatter-graph/ScatterGraph";
export default ReactScatterGraph;
